import Apple from "../assets/Create-Account/apple.svg";
import Email from "../assets/Create-Account/email.svg";
import Google from "../assets/Create-Account/google.svg";
import Instagram from "../assets/Create-Account/instagram.svg";
import tiktok from "../assets/Create-Account/tiktok.svg";
import safeSecureImg from "../assets/landing/safe&secure.svg";
import withdrawls from "../assets/landing/withdrawls.svg";
import support from "../assets/landing/support.svg";
import rewards from "../assets/landing/rewards.png";
import nodeIcon from "../assets/Mobile-Nav-Icons/nodeIcon.svg";
import Wallet from "../assets/Mobile-Nav-Icons/walletIcon.svg";
import person from "../assets/Mobile-Nav-Icons/person.svg";
import support1 from "../assets/Mobile-Nav-Icons/dashboard.svg";
import inbox from "../assets/Mobile-Nav-Icons/inbox.svg";

import Appleicon from "../assets/Create-Account/appWithIcon.svg";
import visaicon from "../assets/Create-Account/visaWithIcon.svg";
import paypalicon from "../assets/Create-Account/paypayWithIcon.svg";
import googleicon from "../assets/Create-Account/googlePayIcon.svg";
import bank from "../assets/Dashboard/bank.svg";
import Logout from "../assets/Dashboard/logout.svg";

export const data = [
  // {
  //   id: 1,
  //   image: tiktok,
  //   text: "Tiktok ",
  // },
  { id: 2, image: Google, text: "Google" },
  { id: 4, image: Apple, text: "Apple" },
  // { id: 3, image: Instagram, text: "Instagram" },
  {
    id: 6,
    image: Email,
    text: "Email",
    link: "/otp-verification",
    link2: "/login",
  },
];
export const financeItems = [
  {
    id: 1,
    logo: safeSecureImg,
    title: "Safe & Secure",
    desc: "Industry standard security ",
  },
  {
    id: 2,
    logo: withdrawls,
    title: "Easy Withdrawals",
    desc: "Unlimited withdrawals anytime ",
  },
  {
    id: 3,
    logo: rewards,
    title: "Rewards",
    desc: "Earn rewards for growth",
  },
];

export const navItems = [
  {
    id: 1,
    icon: person,
    name: "Profile",
    link: "/profile",
  },

  {
    id: 3,
    icon: Wallet,
    name: "Wallet",
    link: "/mainWallet",
  },
  {
    id: 4,
    icon: inbox,
    name: "Inbox",
    link: "/inbox",
  },
  {
    id: 6,
    icon: nodeIcon,
    name: "Campaigns",
    link: "/my-node",
  },
  {
    id: 7,
    icon: support1,
    name: "Support",
    link: "/community-group",
  },
  {
    id: 8,
    icon: Logout,
    name: "Logout",
    link: "/sign-in",
  },
];

export const nodeDetailBreadCrumbs = [
  { label: "Home", url: "/" },
  { label: "Campaign Detail", url: "" },

  // Add more breadcrumb items as needed
];
export const walletBreadCrumbs = [
  { label: "Home", url: "www.eqlizenow.com" },
  { label: "Wallet", url: "www.eqlizenow.com/mainwallet", selected: true },
];

export const rewardBreadCrumbs = [
  { label: "Home", url: "www.eqlizenow.com" },
  { label: "Wallet", url: "www.eqlizenow.com/mainwallet", selected: true },
];

export const userBreadCrumbs = [
  { label: "Home", url: "www.eqlizenow.com" },
  { label: "Wallet", url: "www.eqlizenow.com/mainwallet", selected: true },
];
// Add more breadcrumb items as needed

export const paymentMethods = [
  {
    id: 1,
    type1: "normal",
    type: "reward",
    isChecked: false,
    text1: "Bank",
    image: visaicon,

    text: "Withdraw using your bank account",
  },

  {
    id: 2,
    type1: "normal",
    type: "reward",
    text1: "Paypal",
    image: paypalicon,
    isChecked: false,
    text: "Withdraw using your paypal account",
  },

  {
    id: 3,
    type: "reward",
    isChecked: false,
    text1: "Bank or Debit",
    image: bank,

    text: "Withdraw using Bank or Debit Card  ",
  },

  {
    id: 4,
    type1: "normal",
    type: "reward",
    isChecked: false,
    text1: "Google Pay",
    image: googleicon,

    text: "Google Pay",
  },

  {
    id: 5,
    type1: "normal",
    type: "reward",
    isChecked: false,
    text1: "Apple Pay",
    image: Appleicon,

    text: "Apple Pay",
  },
];

export const chartData = [
  {
    name: "50+",
    uv: 7,
    pv: 4800,
    fill: "#FF2A2A",
  },
  {
    name: "unknown",
    uv: 5,
    pv: 4800,
    fill: "#FF2A2A",
  },
];

export const singleChartData = [
  {
    name: "50+",
    uv: 12,
    pv: 4800,
    fill: "#5AAC41",
  },
];

export const nodeTableData = [
  {
    id: "2154221532",
    joinpeople: "250",
    levels: "20",
    completelevel: "16",
    Button: "",
  },
  {
    id: "2154221532",
    joinpeople: "250",
    levels: "20",
    completelevel: "16",
    Button: "",
  },
  {
    id: "2154221532",
    joinpeople: "250",
    levels: "20",
    completelevel: "16",
    Button: "",
  },
];

export const lineChartData = [
  {
    name: "JAN",
    number: 2,
  },
  {
    name: "FEB",
    number: 3,
  },
  {
    name: "MAR",
    number: 4,
  },
  {
    name: "APR",
    number: 8,
  },
  {
    name: "MAY",
    number: 8,
  },
  {
    name: "JUN",
    number: 4,
  },
  {
    name: "JUL",
    number: 8,
  },
  {
    name: "AUG",
    number: 3,
  },
  {
    name: "SEP",
    number: 8,
  },
  {
    name: "OCT",
    number: 7,
  },
  {
    name: "NOV",
    number: 2,
  },
  {
    name: "DEC",
    number: 8,
  },
];
